module.exports = __webpack_public_path__ + "static/media/Yelp_trademark_RGB.9ea57640.png";